import { render } from "./ProduktDetails.vue?vue&type=template&id=4edd81b2&ts=true"
import script from "./ProduktDetails.vue?vue&type=script&lang=ts"
export * from "./ProduktDetails.vue?vue&type=script&lang=ts"

import "./ProduktDetails.vue?vue&type=style&index=0&id=4edd81b2&lang=scss"

import exportComponent from "/builds/b.braun/pharmacist/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QList from 'quasar/src/components/item/QList.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QSeparator,QIcon,QSelect,QTabs,QTab,QList,QCard,QCardSection,QItem});
